import { AxiosRequestConfig } from 'axios'
import {
  School as Data,
  SchoolCollection as Collection,
} from '@/typings/api/School'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class AteSchoolsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'ate/schools';

  public info(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/info/`
    const [url] = this.getUrl(path, params)
    type IResponse = { data: unknown }
    return this.request<null, IResponse>('GET', url, { params, ...config })
  }

  public getAllLK(params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'lk/'
    const [url] = this.getUrl(path, params)
    type IResponse = { data: unknown }
    return this.request<null, IResponse>('GET', url, { params, ...config })
  }
}
